// extracted by mini-css-extract-plugin
module.exports = {"donor":"support-pledge_donor__3gfpn","donorbox":"support-pledge_donorbox__1XY2y","disclaimer":"support-pledge_disclaimer__1-Win"};